"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));
/* eslint-disable */


var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "74",
    height: "18",
    viewBox: "0 0 74 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M54.7989 17.6832H0C7.13277 16.3124 54.456 16.1068 54.456 16.1068C65.4295 15.9012 73.5225 10.2124 73.5225 10.2124C73.5225 10.2124 68.7216 17.5461 54.7989 17.6832Z",
    fill: "#D39F2A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.1394 5.68876C12.1394 2.60449 14.4713 0 17.7633 0C19.4094 0 20.5067 0.411235 21.4669 1.09663C21.6727 1.23371 21.8784 1.50786 21.8784 1.85056C21.8784 2.39887 21.4669 2.81011 20.9182 2.81011C20.6439 2.81011 20.5067 2.67303 20.301 2.60449C19.6151 2.05618 18.8607 1.71348 17.6262 1.71348C15.6372 1.71348 14.0598 3.4955 14.0598 5.55168C14.0598 7.81348 15.5686 9.45843 17.7633 9.45843C18.7921 9.45843 19.7523 9.11573 20.3696 8.63595V6.57977H18.2434C17.7633 6.57977 17.3518 6.23708 17.3518 5.7573C17.3518 5.27753 17.7633 4.93483 18.2434 4.93483H21.2611C21.8098 4.93483 22.2213 5.34607 22.2213 5.89438V8.84157C22.2213 9.38989 22.0156 9.80112 21.5355 10.0753C20.5753 10.6921 19.2722 11.2404 17.6262 11.2404C14.4027 11.309 12.1394 8.84157 12.1394 5.68876Z",
    fill: "#D39F2A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.416 5.68876C24.416 2.60449 26.8165 0 30.1771 0C33.5377 0 35.8696 2.53595 35.8696 5.62022C35.8696 8.70449 33.4692 11.2404 30.1085 11.2404C26.7479 11.309 24.416 8.77303 24.416 5.68876ZM33.8121 5.68876C33.8121 3.56404 32.2347 1.78202 30.1085 1.78202C27.9138 1.78202 26.405 3.4955 26.405 5.62022C26.405 7.74494 27.9824 9.52696 30.1085 9.52696C32.3032 9.52696 33.8121 7.81348 33.8121 5.68876Z",
    fill: "#D39F2A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.1329 1.02816C38.1329 0.479841 38.5444 0.0686035 39.0931 0.0686035C39.6418 0.0686035 40.0533 0.479841 40.0533 1.02816V9.32141H44.9913C45.4714 9.32141 45.8829 9.73265 45.8829 10.2124C45.8829 10.6922 45.4714 11.1034 44.9913 11.1034H39.0931C38.5444 11.1034 38.1329 10.6922 38.1329 10.1439V1.02816Z",
    fill: "#D39F2A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.8719 1.16511C47.8719 0.616801 48.2834 0.205566 48.832 0.205566H51.9183C55.3476 0.205566 57.748 2.5359 57.748 5.62017C57.748 8.70444 55.3476 11.1033 51.9183 11.1033H48.832C48.2834 11.1033 47.8719 10.6921 47.8719 10.1438V1.16511ZM51.9183 9.32129C54.1816 9.32129 55.6905 7.74489 55.6905 5.62017C55.6905 3.49545 54.1816 1.91905 51.9183 1.91905H49.7922V9.32129H51.9183Z",
    fill: "#D39F2A"
  }));
};

exports.default = _default;